var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 108,
    viewBox: "0 0 343 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_292_1491)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 108,
    rx: 16,
    fill: "url(#paint0_linear_292_1491)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M51.5424 23.6663C25.614 5.66247 5.62564 9.08698 -5.98512 13.3928C-8.26022 35.3667 -11.4454 81.7117 -5.98512 91.3003C0.840179 103.286 43.5 134 104.195 114.416C136.44 104.011 283.928 124.118 347.955 114.416C354.781 77.6023 364.336 -37.2899 347.955 -37.9748C327.479 -38.831 279.658 -17.8741 246.461 30.925C203.072 94.7064 186.009 8.23085 137.744 -1.61461C110.136 -7.24637 77.5164 41.7018 51.5424 23.6663Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M47.5525 32.653C26.4744 24.8494 7.99049 32.0905 -5.98512 32.653C-8.26022 54.3106 -11.4454 99.9885 -5.98512 109.439C0.840178 121.252 62.2679 126.315 104.195 132.222C137.736 136.947 283.928 119.002 347.955 109.439C354.781 73.1556 364.336 -17.3002 347.955 -17.9752C327.479 -18.819 279.658 1.83615 246.461 49.9328C203.072 112.796 134.331 97.6077 109.955 75.6688C90.3102 57.9879 74.8537 42.7605 47.5525 32.653Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_292_1491",
    x: -35,
    y: -25,
    width: 413,
    height: 178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.501961 0 0 0 0 0.941176 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_292_1491"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_292_1491",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_292_1491",
    x1: 0,
    y1: 108,
    x2: 155.261,
    y2: -125.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#441DFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E81EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBanner);
export default __webpack_public_path__ + "static/media/blue-banner.d2cdadcfeac4475cbeaff9bae060cfe6.svg";
export { ForwardRef as ReactComponent };